module.exports = __webpack_public_path__ + "static/img/1ortho5.cb776a9a.png";